export enum LearnerEventType {
    RESERVED = 'RESERVED', // Bảo lưu
    ENROLL = 'ENROLL', // Học chính thức
    LEFT = 'LEFT', // Nghỉ
    TEST_MID = 'TEST_MID', // Thi mid
    TEST_FINAL = 'TEST_FINAL' // Thi final
}

export const EVENT_TYPE_MAP: any = {
    [LearnerEventType.RESERVED]: 'Bảo lưu',
    [LearnerEventType.ENROLL]: 'Học chính thức',
    [LearnerEventType.LEFT]: 'Nghỉ',
    [LearnerEventType.TEST_MID]: 'Thi mid',
    [LearnerEventType.TEST_FINAL]: 'Thi final'
};

export enum ExtendedLearnerEventType {
    // Sign up
    LEN_SIGN = 'LÊN SIGN',
    TANG_LOP = 'TẶNG LỚP',

    // Trial and waiting
    HOC_THU = 'HỌC THỬ',
    HOC_CHO = 'HỌC CHỜ',
    HOC_CHO_CO_THI = 'HỌC CHỜ (CÓ THI)',

    // New enrollment
    HOC_MOI_PAID = 'HỌC MỚI (PAID)',
    HOC_MOI_TANG = 'HỌC MỚI (TẶNG)',
    HOC_KEM = 'HỌC KÈM',

    // Re-enrollment
    HOC_LAI_BL = 'HỌC LẠI (BL)',
    HOC_LAI_ROT = 'HỌC LẠI (RỚT)',
    HOC_LAI_CANCEL = 'HỌC LẠI (CANCEL)',
    HOC_LAI_OTHER = 'HỌC LẠI (OTHER)',
    HOC_LAI_CANCEL_R = 'HỌC LẠI (CANCEL - R)',
    HOC_LAI_CANCEL_BL = 'HỌC LẠI (CANCEL - BL)',
    HOC_LAI_CANCEL_OTHER = 'HỌC LẠI (CANCEL - OTHER)',

    // Test results
    PASS = 'PASS',
    FAIL = 'FAIL',
    BARELY = 'BARELY',
    BO_THI = 'BỎ THI',

    // Leave/pause
    BAO_LUU = 'BẢO LƯU',
    NGHI = 'NGHỈ',
    NGHI_CANCEL = 'NGHỈ (CANCEL)',
    CHUYEN_LOP = 'CHUYỂN LỚP',
    NGHI_THU = 'NGHỈ (THỬ)',
    NGHI_CHO = 'NGHỈ (CHỜ)',

    // Transfer
    CHUYEN_NHUONG = 'CHUYỂN NHƯỢNG',
    DUOC_CHUYEN_NHUONG = 'ĐƯỢC CHUYỂN NHƯỢNG',

    // Other
    HUY_CKDR = 'HUỶ CKĐR',
    PHUC_HOI_CKDR = 'PHỤC HỒI CKĐR',
    TEST_MID = 'TEST_MID'
}

export const EXTENDED_LEARNER_EVENT_TYPE_CONFIG = {
    // Sign up
    [ExtendedLearnerEventType.LEN_SIGN]: {
        label: 'Lên sign',
        cssClass: 'text-sm !bg-teal-200 !text-teal-900'
    },
    [ExtendedLearnerEventType.TANG_LOP]: {
        label: 'Tặng lớp',
        cssClass: 'text-sm !bg-teal-200 !text-teal-900'
    },

    // Trial and waiting
    [ExtendedLearnerEventType.HOC_THU]: {
        label: 'Học thử',
        cssClass: 'text-sm !bg-purple-200 !text-purple-900'
    },
    [ExtendedLearnerEventType.HOC_CHO]: {
        label: 'Học chờ',
        cssClass: 'text-sm !bg-slate-200 !text-slate-800'
    },
    [ExtendedLearnerEventType.HOC_CHO_CO_THI]: {
        label: 'Học chờ (có thi)',
        cssClass: 'text-sm !bg-slate-200 !text-slate-800'
    },

    // New enrollment
    [ExtendedLearnerEventType.HOC_MOI_PAID]: {
        label: 'Học mới (paid)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_MOI_TANG]: {
        label: 'Học mới (tặng)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_KEM]: {
        label: 'Học kèm',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },

    // Re-enrollment
    [ExtendedLearnerEventType.HOC_LAI_BL]: {
        label: 'Học lại (BL)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_ROT]: {
        label: 'Học lại (Rớt)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_CANCEL]: {
        label: 'Học lại (paid)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_OTHER]: {
        label: 'Học lại (other)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_CANCEL_R]: {
        label: 'Học lại (paid)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_CANCEL_BL]: {
        label: 'Học lại (paid)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },
    [ExtendedLearnerEventType.HOC_LAI_CANCEL_OTHER]: {
        label: 'Học lại (paid)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-700'
    },

    // Test results
    [ExtendedLearnerEventType.PASS]: {
        label: 'Pass',
        cssClass: 'text-sm !bg-green-200 !text-green-800'
    },
    [ExtendedLearnerEventType.FAIL]: {
        label: 'Fail',
        cssClass: 'text-sm !bg-red-200 !text-red-900'
    },
    [ExtendedLearnerEventType.BARELY]: {
        label: 'Barely',
        cssClass: 'text-sm !bg-yellow-200 !text-yellow-900'
    },
    [ExtendedLearnerEventType.BO_THI]: {
        label: 'Bỏ thi',
        cssClass: 'text-sm !bg-orange-200 !text-orange-900'
    },

    // Leave/pause
    [ExtendedLearnerEventType.BAO_LUU]: {
        label: 'Bảo lưu',
        cssClass: 'text-sm !bg-sky-200 !text-sky-900'
    },
    [ExtendedLearnerEventType.NGHI]: {
        label: 'Nghỉ',
        cssClass: 'text-sm !bg-gray-200 !text-gray-800'
    },
    [ExtendedLearnerEventType.NGHI_CANCEL]: {
        label: 'Nghỉ (cancel)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-800'
    },
    [ExtendedLearnerEventType.CHUYEN_LOP]: {
        label: 'Chuyển lớp',
        cssClass: 'text-sm !bg-blue-200 !text-blue-900'
    },
    [ExtendedLearnerEventType.NGHI_THU]: {
        label: 'Nghỉ (thử)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-800'
    },
    [ExtendedLearnerEventType.NGHI_CHO]: {
        label: 'Nghỉ (chờ)',
        cssClass: 'text-sm !bg-gray-200 !text-gray-800'
    },

    // Transfer
    [ExtendedLearnerEventType.CHUYEN_NHUONG]: {
        label: 'Chuyển nhượng',
        cssClass: 'text-sm !bg-blue-200 !text-blue-900'
    },
    [ExtendedLearnerEventType.DUOC_CHUYEN_NHUONG]: {
        label: 'Được chuyển nhượng',
        cssClass: 'text-sm !bg-blue-200 !text-blue-900'
    },

    // Other
    [ExtendedLearnerEventType.HUY_CKDR]: {
        label: 'Huỷ CKĐR',
        cssClass: 'text-sm !bg-amber-200 !text-amber-900'
    },
    [ExtendedLearnerEventType.PHUC_HOI_CKDR]: {
        label: 'Phục hồi CKĐR',
        cssClass: 'text-sm !bg-amber-200 !text-amber-900'
    },
    [ExtendedLearnerEventType.TEST_MID]: {
        label: 'Thi mid',
        cssClass: 'text-sm !bg-amber-200 !text-amber-900'
    }
};
